import ApiService from '@/services/core/api.service'

const InvalidPendingDataService = {
  async get (query) {
    return ApiService.get(`agent/invalid-pending-data?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/invalid-pending-data', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/invalid-pending-data/${payload.id}`, payload)
  }
}

export default InvalidPendingDataService
